'use client';

import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Stats from '@alltrails/core/types/Stats';
import Heading from '@alltrails/denali/components/Heading';
import CultureStat from './CultureStat';
import styles from './styles/OurCulture.module.scss';
import Video from './Video';

const OurCulture = () => {
  const intl = useIntl();
  const TEN_K_REASONS = intl.formatMessage({ defaultMessage: '10k reasons to get outside' });

  return (
    <div className={styles.container}>
      <Video title={TEN_K_REASONS} />
      <div className={styles.textContent}>
        <Heading as="h2" className={styles.header} size="500">
          {TEN_K_REASONS}
        </Heading>
        <Typography component="div" variant="text300" mb="32">
          {intl.formatMessage({
            defaultMessage:
              'The more we grow, the more we realize all the ways that nature connects us: to ourselves, to the past, to the ecosystems we live within, and to each other. Here’s to more trails and more community members with even more reasons to get outside.'
          })}
        </Typography>
        <div className={styles.divider} />
        <div className={styles.statsContainer}>
          <CultureStat
            title={intl.formatMessage({ defaultMessage: '{value}K+' }, { value: Stats.NumCuratedTrails })}
            subtitle={intl.formatMessage({ defaultMessage: 'curated trails' })}
          />
          <CultureStat
            title={intl.formatMessage({ defaultMessage: '{value}M+' }, { value: Stats.NumUsers })}
            subtitle={intl.formatMessage({ defaultMessage: 'fellow explorers' })}
          />
          <CultureStat title={intl.formatMessage({ defaultMessage: '1' })} subtitle={intl.formatMessage({ defaultMessage: 'global community' })} />
        </div>
      </div>
    </div>
  );
};

export default OurCulture;
